import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    // Extract payment details from URL parameters
    const txRef = searchParams.get('tx_ref');
    const status = searchParams.get('status');
    const amount = searchParams.get('amount');
    const currency = searchParams.get('currency');

    if (txRef) {
      setPaymentDetails({
        txRef,
        status,
        amount,
        currency: currency || 'ETB'
      });
    }
  }, [searchParams]);

  return (
    <div className="payment-success-container">
      <div className="payment-success-content">
        <div className="success-icon">
          ✅
        </div>
        
        <h1 className="success-title">
          Payment Successful!
        </h1>
        
        <p className="success-message">
          እናመሰግናለን! Thank you for your generous support to our ministry.
        </p>

        {paymentDetails && (
          <div className="payment-details">
            <h3>Payment Details</h3>
            <div className="detail-item">
              <span className="detail-label">Transaction Reference:</span>
              <span className="detail-value">{paymentDetails.txRef}</span>
            </div>
            {paymentDetails.amount && (
              <div className="detail-item">
                <span className="detail-label">Amount:</span>
                <span className="detail-value">{paymentDetails.amount} {paymentDetails.currency}</span>
              </div>
            )}
            <div className="detail-item">
              <span className="detail-label">Status:</span>
              <span className="detail-value success-status">Completed</span>
            </div>
          </div>
        )}

        <div className="success-message-box">
          <h3>🙏 Your Support Matters</h3>
          <p>
            Your donation helps us continue providing free access to Orthodox spiritual resources, 
            including daily readings, prayers, and religious texts to our community.
          </p>
          <p>
            የእርስዎ ድጋፍ ነፃ የሆኑ የኦርቶዶክስ መንፈሳዊ ሀብቶችን፣ የዕለት ንባቦችን፣ ጸሎቶችን እና ሃይማኖታዊ መጻሕፍትን 
            ለማህበረሰባችን ማቅረብ እንድንቀጥል ይረዳናል።
          </p>
        </div>

        <div className="success-actions">
          <Link to="/" className="btn-primary">
            🏠 Return to Home
          </Link>
          <Link to="/books" className="btn-secondary">
            📚 Browse Books
          </Link>
        </div>

        <div className="contact-info">
          <p>
            If you have any questions about your donation, please contact us:
          </p>
          <p>
            📧 Email: support@gitsawe.com<br/>
            📱 Phone: +251938169557
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;